import type { PropsWithChildren } from 'react'

type ContactFieldProps = PropsWithChildren<{
  error?: string
  htmlFor: string
  label: string
}>

export function ContactField({ children, error, htmlFor, label }: ContactFieldProps) {
  const errorId = `${htmlFor}-error`

  return (
    <div>
      <label className="mb-2 block text-sm font-medium text-phosphor-ivory" htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {error ? (
        <p className="contact-feedback contact-feedback-error" id={errorId}>
          {error}
        </p>
      ) : null}
    </div>
  )
}
